import React, { useCallback, useEffect, useState } from 'react';
import { profile, authentication } from '@/actions';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import Container from '@/components/Container';
import { RootState, useAppSelector } from '@/state/store';
import { AuthenticationStatus } from '@/contracts';
import { AccessErrorCodes } from '@bimdata/definitions/errors/access.error';
import t from '@/utils/translate';
import { Messages } from '@/components';

const redirectUrl = "/profile";

export default () => {
  const { code } = useParams();

  const isAuthenticated = useAppSelector((state: RootState) => state.authentication.status === AuthenticationStatus.AUTHENTICATED);

  const nav = useNavigate();
  const [result, setResult] = useState<true | string | undefined>(undefined);

  const success = () => {
    window.setTimeout(() => {
      nav(redirectUrl, { replace: true });
      nav(0);
    }, 5000);
    setResult(true);
  };

  const fail = (error: Error) => {
    window.setTimeout(() => {
      nav(isAuthenticated ? redirectUrl : '/', { replace: true });
      nav(0);
    }, 5000);
    setResult(error.message);
  };  

  const tryLogin = useCallback(() => {
    if (code) {
      authentication.loginByEmailConfirm(code)
        .then(success)
        .catch(fail);
    }
  }, [code])

  useEffect(() => {
    if (code && !result) {
      if (isAuthenticated) {
        profile.confirmEmail(code)
          .then(success)
          .catch((error) => {
            if (error.code === 403 && error.exceptionCode === AccessErrorCodes.ACCESS_DENIED) {
              tryLogin();
              return;
            }
            fail(error);
          });
      } else {
        tryLogin();
      }
    }
  }, []);

  if (code) {
    if (result === true) {
      return (
        <Container margin-h='medium' text-align='center'>
          <h3>{t('verification.message.emailConfirmed')}</h3>
        </Container>
      );
    }

    if (typeof result === 'string') {
      return (
        <Container margin-h='medium' text-align='center'>
          <h3>{result}</h3>
        </Container>
      );
    }

    return (
      <Container margin-h='medium' text-align='center'>
        <h3>{t('verification.title.emailConfirmation')}</h3>
        <Messages />
      </Container>
    );
  }

  return <Navigate to={redirectUrl} replace/>;
};
